import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';

import { PageAction } from '../../components/page-actions/page-actions.component';
import { ImportService } from '@services/imports/import.service';
import { DataTableEvent } from '../../components/data-table/data-table.component';
import { environment } from '../../../environments/environment';
import { MessengerService } from '@services/messenger/messenger.service';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-importer-monitor',
    templateUrl: './importer-monitor.component.html',
    styleUrls: ['./importer-monitor.component.scss'],
    providers: [ImportService],
    standalone: false
})
export class ImporterMonitorComponent implements OnInit {

  public title = 'Monitoring Imports';

  public pageActions: PageAction[];

  public importTypeId: string;

  public columns = [
    { prop: 'title', name: 'Title' },
    {
      prop: 'lastSuccessed', name: 'Last Successed', valueTransformer: function(date) {
        return moment(date).format('DD-MM-YYYY  HH:mm');
      }
    },
    {
      prop: 'lastCheck', name: 'lastCheck', valueTransformer: function(date) {
        return moment(date).format('DD-MM-YYYY  HH:mm');
      }
    },
    {
      prop: 'nextCheck', name: 'nextCheck', valueTransformer: function(date) {
        return moment(date).format('DD-MM-YYYY  HH:mm');
      }
    },
    { prop: 'lastJobDuration', name: 'Duration' },
  ];

  public params: any;

  constructor(
    public importService: ImportService,
    private route: ActivatedRoute,
    private router: Router,
    private ms: MessengerService,
    private http: HttpClient
  ) {
  }

  ngOnInit() {
    this.createPageActions();
    this.importTypeId = this.route.snapshot.params['id'];
    this.params = {};
    this.params['$sort'] = { lastJobDuration: -1 };
  }

  public onDetail(event: DataTableEvent): void {
    this.router.navigate(['imports', event.row._id]);
  }

  public onCustom(event: DataTableEvent): void {
    this.router.navigate(['import-logs/', 'importId', event.row._id]);
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'access_time',
        title: 'Check duration of jobs',
        callback: () => {
          this.params = {};
          this.params['$sort'] = { lastJobDuration: -1 };
          this.columns = [
            { prop: 'title', name: 'Title' },
            {
              prop: 'lastSuccessed', name: 'Last Successed',
              valueTransformer: function(successDate) {
                if (!successDate) { return null }
                return moment(successDate).format('DD-MM-YYYY  HH:mm');
              }
            },
            {
              prop: 'lastCheck', name: 'lastCheck',
              valueTransformer: function(checkedDate) {
                if (!checkedDate) { return null }
                return moment(checkedDate).format('DD-MM-YYYY  HH:mm');
              }
            },
            {
              prop: 'nextCheck', name: 'nextCheck',
              valueTransformer: function(nextCheckDate) {
                if (!nextCheckDate) { return null }
                return moment(nextCheckDate).format('DD-MM-YYYY  HH:mm');
              }
            },
            { prop: 'lastJobDuration', name: 'Duration' },
          ];

        }
      }),
      new PageAction({
        icon: 'access_time',
        title: 'List oldest LastCheck',
        callback: () => {
          this.params = {};
          this.params['$sort'] = { lastCheck: 1 };
          this.columns = [
            { prop: 'title', name: 'Title' },
            {
              prop: 'lastSuccessed', name: 'Last Successed',
              valueTransformer: function(successDate) {
                if (!successDate) { return null }
                return moment(successDate).format('DD-MM-YYYY  HH:mm');
              }
            },
            {
              prop: 'lastCheck', name: 'lastCheck',
              valueTransformer: function(checkedDate) {
                if (!checkedDate) { return null }
                return moment(checkedDate).format('DD-MM-YYYY  HH:mm');
              }
            },
            { prop: 'autoUpdate', name: 'AutoUpdate' },
            { prop: 'autoUpdateInterval', name: 'AutoUpdate' }
          ];

        }
      }),
      new PageAction({
        icon: 'sentiment_dissatisfied',
        title: 'Check failed Status',
        callback: () => {
          this.params = { 'jobStatus.lastFailedJob': { $exists: true } };
          this.params['$sort'] = { 'jobStatus.lastFailedJob': -1 };
          this.columns = [
            { prop: 'title', name: 'Title' },
            {
              prop: 'lastSuccessed', name: 'Last Successed',
              valueTransformer: function(successDate) {
                if (!successDate) { return null }
                return moment(successDate).format('DD-MM-YYYY  HH:mm');
              }
            },
            {
              prop: 'jobStatus.lastFailedJob', name: 'lastFailedJob',
              valueTransformer: function(failedDate) {
                if (!failedDate) { return null }
                return moment(failedDate).format('DD-MM-YYYY  HH:mm');
              }
            },
            { prop: 'jobStatus.lastFailedReason', name: 'Reason' },
            { prop: 'jobStatus.failedJobCounter', name: 'Counter' },
          ];

        }
      }),
      new PageAction({
        icon: 'sentiment_very_dissatisfied',
        title: 'Check stucked Inactive',
        callback: () => {
          this.params = { 'jobStatus.lastRemovedAsInactiveJob': { $exists: true } };
          this.params['$sort'] = { 'jobStatus.lastRemovedAsInactiveJob': -1 };
          this.columns = [
            { prop: 'title', name: 'Title' },
            {
              prop: 'lastSuccessed', name: 'Last Successed',
              valueTransformer: function(successDate) {
                if (!successDate) { return null }
                return moment(successDate).format('DD-MM-YYYY  HH:mm');
              }
            },
            { prop: 'jobStatus.removedAsInactiveCounter', name: 'Counter' },
            {
              prop: 'jobStatus.lastRemovedAsInactiveJob', name: 'Last Removed',
              valueTransformer: function(removeDate) {
                if (!removeDate) { return null }
                return moment(removeDate).format('DD-MM-YYYY  HH:mm');
              }
            }
          ];

        }
      }),
      new PageAction({
        icon: 'sentiment_very_dissatisfied',
        title: 'Check stucked Active',
        callback: () => {
          this.params = { 'jobStatus.lastRemovedAsActiveJob': { $exists: true } };
          this.params['$sort'] = { 'jobStatus.lastRemovedAsActiveJob': -1 };
          this.columns = [
            { prop: 'title', name: 'Title' },
            {
              prop: 'lastSuccessed', name: 'Last Successed',
              valueTransformer: function(successDate) {
                if (!successDate) { return null }
                return moment(successDate).format('DD-MM-YYYY  HH:mm');
              }
            },
            { prop: 'jobStatus.removedAsActiveCounter', name: 'Counter' },
            {
              prop: 'jobStatus.lastRemovedAsActiveJob', name: 'Last Removed',
              valueTransformer: function(removeDate) {
                if (!removeDate) { return null }
                return moment(removeDate).format('DD-MM-YYYY  HH:mm');
              }
            }
          ];

        }
      }),
      new PageAction({
        /*
         * this should be used only once, then it is deprecated :(
         * all import orphans should be removed by the hook
         * the content-filter are not cleaned-up - because their model is currently not available.
         */

        icon: 'trash',
        title: 'Remove Orphans',
        callback: () => {
          let backendUrl = environment.apiBaseURL;
          if (this.ms.getActiveAPI() === 'live' || this.ms.getActiveAPI() === 'staging') {
            backendUrl = environment[this.ms.getActiveAPI()].apiBaseURL;
          }
          const apiKey = 'VOAgng4vD1|F4V62kuGXb+aFMS4hyyWqjHumODlVnhxLk4zCKWsH70nkdfvWDLpH9VSfp11zom8xaOKvF7xctxLQs6ZdthySA==';
          const params = '?api_key=' + encodeURIComponent(apiKey);
          return this.http.get(backendUrl + '/removeImportOrphans' + params).toPromise().then(result => {
            console.log('removeImportOrphans result: ');
            console.log(result);
          });
        }
      })
    ];
  }

}
